module.exports = __webpack_public_path__ + "static/img/img_helpnow_ai.74a7c37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_helpnow_ai.png
// module id = 11eU
// module chunks = 1